import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import sprite from '../../../../img/sprites.svg';

import { openToggle, toggle } from '../../../../utils/accordion';

import ProgramsCard from '../ProgramsCard/ProgramsCard';
import ProgramsTable from '../ProgramsTable/ProgramsTable';

const ProgramsBlock = ({ title, courses, initiallyOpen }) => {
  useEffect(() => {
    if (courses.length > 0) {
      // відкриваємо тільки ті блоки, що вже мають клас `open`
      const blocks = document.querySelectorAll('.page-block.open[data-block="toggle"]');
      blocks.forEach(block => {
        openToggle(block);
      });
    }
  }, [courses]);

  const handleToggle = (target) => {
    const btn = target.closest('[data-top="toggle"]');
    const block = target.closest('[data-block="toggle"]');

    if (btn && block) {
      toggle(block);
    }
  };

  return (
    <div
      className={`page-block ${initiallyOpen ? 'open' : ''}`}
      data-block="toggle"
    >
      <button
        type="button"
        className="page-block-head"
        data-top="toggle"
        onClick={(e) => handleToggle(e.target)}
      >
        <h3 className="page-block-head__title">{title}</h3>
        <svg className="icon">
          <use href={`${sprite}#arrow`}></use>
        </svg>
      </button>

      <div className="page-block__content" data-content="toggle">
        <div className="page__cards cards">
          {courses.length > 0 &&
            courses.map(course => (
              <ProgramsCard key={course.program_id} course={course} />
            ))
          }
        </div>

        <div className="page__table table">
          {courses.length > 0 && <ProgramsTable courses={courses} />}
        </div>
      </div>
    </div>
  );
};

ProgramsBlock.propTypes = {
  courses: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  initiallyOpen: PropTypes.bool,
};

ProgramsBlock.defaultProps = {
  initiallyOpen: true,
};

export default ProgramsBlock;